export const CampaignRouteParameters = {
  CampaignId: 'campaignId',
} as const;
